import React from "react";

import LockIcon from "@uui/Lock03";

import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateSubtext,
  EmptyStateTitle,
} from "@rui/EmptyStateContainer";
import Stack from "@rui/Stack";

const LABELS = {
  forYou: "For You",
  tag: "Your Tags",
  workspace: "Your Workspace",
  team: "Your Teams",
};

const NoAccess = ({
  type,
}: {
  type: "forYou" | "tag" | "workspace" | "team";
}) => {
  return (
    <Stack height="100%" paddingTop={2}>
      <EmptyStateContainer>
        <EmptyStateIcon Icon={LockIcon} />
        <EmptyStateTitle>Access restricted</EmptyStateTitle>
        <EmptyStateSubtext>
          {LABELS[type]} Page is reprocessing based on a change in access to
          select report(s). You should see an updated report within 24 hours of
          your next meeting.
        </EmptyStateSubtext>
      </EmptyStateContainer>
    </Stack>
  );
};

export default NoAccess;
